import { render, staticRenderFns } from "./bankaccount2.vue?vue&type=template&id=80c83766&scoped=true&"
import script from "./bankaccount2.vue?vue&type=script&lang=js&"
export * from "./bankaccount2.vue?vue&type=script&lang=js&"
import style0 from "./bankaccount2.vue?vue&type=style&index=0&id=80c83766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c83766",
  null
  
)

export default component.exports